//jshint esversion:6
import '../styles/MainContent.css';
import React, { useEffect } from 'react';
import '../App.css';
function MainContent() {
  useEffect(() => {
    /* setTimeout(function(){
          document.getElementById("aud").play();
          console.log('audio started');
        }, 8000);
    
      */
    var aText = ['Hyy,I am hardik'];

    var iSpeed = 100; // time delay of print out
    var iIndex = 0; // start printing array at this posision
    var iArrLength = aText[0].length; // the length of the text array
    var iScrollAt = 20; // start scrolling up at this many lines

    var iTextPos = 0; // initialise text position
    var sContents = ''; // initialise contents variable
    var iRow; // initialise current row

    function typewriter() {
      sContents = ' ';
      iRow = Math.max(0, iIndex - iScrollAt);

      var destination = document.getElementById('typedtext');

      while (iRow < iIndex) {
        sContents += aText[iRow++] + '<br />';
      }
      destination.innerHTML = sContents + aText[iIndex].substring(0, iTextPos);
      if (iTextPos++ === iArrLength) {
        iTextPos = 0;
        iIndex++;
        if (iIndex !== aText.length) {
          iArrLength = aText[iIndex].length;
          setTimeout(typewriter, 1000);
        }
      } else {
        setTimeout(typewriter, iSpeed);
      }
    }
    typewriter();
  }, []);
  return (
    <div>
      <div class='back container-fluid '>
        <div>
          <span className='emoji-me'>👦</span>
        </div>

        <b>
          <div id='typedtext' className='text-div'></div>
        </b>
        <div class='short-bio'>
          A Tech savvy developer passionate to work on some impactful projects
        </div>
      </div>
    </div>
  );
}

export default MainContent;
